var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Component from "../lib/component";
import html from "./tag-input.html";
import "./tag-input.scss";
import * as http from '../app-lib/ajax_proxy';
var MyComponent = /** @class */ (function (_super) {
    __extends(MyComponent, _super);
    function MyComponent() {
        var _this = _super.call(this, "tag-input", html) || this;
        _this.term = ko.observable(''); //查询字符串
        _this.tmplist = ko.observableArray([]); //查询出来数据的列表
        return _this;
    }
    MyComponent.prototype.init = function () {
        this.options.minTermLength = this.options.minTermLength || 1;
        this.list = this.options.value || ko.observableArray();
    };
    MyComponent.prototype.onkeyup = function (c, e) {
        var _this = this;
        console.log(c.term()); //改动 换成店即将搜索
        // let input = e.currentTarget as HTMLInputElement
        // console.log(input.value);
        // if(input.value==''||input.value==undefined||input.value==null){
        //     this.tmplist([]);
        //     return;
        // }
        //     http.get(this.options.dataSource + input.value).then(d =>
        //         this.tmplist(d.data)
        //     )
        if (c.term().trim() == '' || c.term() == undefined || c.term() == null) {
            this.tmplist([]);
            return;
        }
        http.get(this.options.dataSource, { name: c.term() }).then(function (d) {
            return _this.tmplist(d.data);
        });
        return true;
    };
    MyComponent.prototype.selectIt = function (item) {
        this.list.push(item);
        this.tmplist([]);
        this.term("");
    };
    MyComponent.prototype.deleteIt = function (index) {
        this.list.splice(index, 1);
    };
    return MyComponent;
}(Component));
export default new MyComponent();
